import React, { Component } from "react";
import Session from "../../utility/session";

class Profile extends Component {
  render() {
    const current_name = Session.getItem(Session.CURRENT_NAME);
    return (
      <div className="profile clearfix">
        <div className="profile_pic">
          <img
            src={process.env.PUBLIC_URL + "assets/images/default-profile.png"}
            alt="Profile"
            className="img-circle profile_img"
          />
        </div>
        <div className="profile_info">
          <span>Welcome,</span>
          <h2>{current_name}</h2>
        </div>
      </div>
    );
  }
}
export default Profile;



// WEBPACK FOOTER //
// ./src/components/SideBar/Profile.js